import { useState } from "react";

export default function SubscribeCta() {
  const [followed, setFollowed] = useState(false);
  const [toast, setToast] = useState("");

  const handleFollow = () => {
    setFollowed(true);
    setToast("已加入关注清单，热度冲榜时会提醒你");
    window.setTimeout(() => setToast(""), 2600);
  };

  const handleNotify = () => {
    setToast("已记录你的提醒偏好，榜单更新将优先推送");
    window.setTimeout(() => setToast(""), 2600);
  };

  return (
    <section id="subscribe" className="bg-background-100">
      <div className="mx-auto max-w-[1200px] px-4 py-14 md:px-6 md:py-20">
        <div className="relative overflow-hidden rounded-lg bg-foreground-900 px-6 py-10 md:px-12 md:py-14">
          <div className="pointer-events-none absolute -right-16 -top-16 hidden h-64 w-64 rounded-full bg-primary-600/40 blur-3xl md:block" />
          <div className="pointer-events-none absolute -bottom-20 left-1/3 hidden h-56 w-56 rounded-full bg-accent-600/30 blur-3xl md:block" />

          <div className="relative grid grid-cols-1 items-center gap-8 lg:grid-cols-[1.2fr_0.8fr]">
            <div>
              <span className="mb-4 inline-flex items-center gap-2 rounded-full border border-background-50/20 bg-background-50/10 px-3.5 py-1.5">
                <i className="ri-notification-3-line text-sm text-accent-300" />
                <span className="text-xs font-medium text-background-100">热度提醒</span>
              </span>
              <h2 className="font-heading text-2xl font-bold leading-snug text-background-50 md:text-[34px]">
                别错过下一次冲榜
              </h2>
              <p className="mt-4 max-w-xl text-sm leading-relaxed text-background-200 md:text-[15px]">
                当某条 31黑料网最火黑料 的热度在短时间内快速攀升，我们会把它从榜单里单独拎出来提醒你。
                关注后，你看到的始终是当前最该看的那几条。
              </p>
              <div className="mt-7 flex flex-col gap-3 sm:flex-row sm:items-center">
                <button
                  type="button"
                  onClick={handleFollow}
                  className={`flex items-center justify-center gap-2 whitespace-nowrap rounded-md px-6 py-3 text-sm font-medium transition-colors ${
                    followed
                      ? "bg-accent-500 text-accent-950"
                      : "bg-primary-500 text-background-50 hover:bg-primary-600"
                  }`}
                >
                  <i className={followed ? "ri-check-line text-base" : "ri-add-line text-base"} />
                  {followed ? "已关注" : "关注热度榜"}
                </button>
                <button
                  type="button"
                  onClick={handleNotify}
                  className="flex items-center justify-center gap-2 whitespace-nowrap rounded-md border border-background-50/25 px-6 py-3 text-sm font-medium text-background-100 transition-colors hover:border-background-50/60 hover:text-background-50"
                >
                  <i className="ri-mail-send-line text-base" />
                  开启榜单推送
                </button>
              </div>
              <p className="mt-4 text-xs text-background-300">
                演示站点：按钮仅展示交互反馈，不会真实提交或发送通知。
              </p>
            </div>

            <div className="grid grid-cols-2 gap-3">
              <div className="rounded-lg border border-background-50/15 bg-background-50/5 p-4">
                <i className="ri-flashlight-line text-xl text-accent-300" />
                <p className="mt-3 font-heading text-lg font-bold text-background-50">10 分钟</p>
                <p className="mt-1 text-xs text-background-300">榜单滚动周期</p>
              </div>
              <div className="rounded-lg border border-background-50/15 bg-background-50/5 p-4">
                <i className="ri-stack-line text-xl text-primary-300" />
                <p className="mt-3 font-heading text-lg font-bold text-background-50">86 个</p>
                <p className="mt-1 text-xs text-background-300">在架专题合集</p>
              </div>
              <div className="rounded-lg border border-background-50/15 bg-background-50/5 p-4">
                <i className="ri-shield-check-line text-xl text-accent-300" />
                <p className="mt-3 font-heading text-lg font-bold text-background-50">标注来源</p>
                <p className="mt-1 text-xs text-background-300">每条附时间与出处</p>
              </div>
              <div className="rounded-lg border border-background-50/15 bg-background-50/5 p-4">
                <i className="ri-recycle-line text-xl text-primary-300" />
                <p className="mt-3 font-heading text-lg font-bold text-background-50">可回溯</p>
                <p className="mt-1 text-xs text-background-300">保留 90 天记录</p>
              </div>
            </div>
          </div>
        </div>
      </div>

      {toast && (
        <div className="fixed bottom-6 left-1/2 z-[60] -translate-x-1/2">
          <div className="flex items-center gap-2 rounded-full bg-foreground-950 px-4 py-2.5">
            <i className="ri-checkbox-circle-fill text-base text-accent-400" />
            <span className="whitespace-nowrap text-xs font-medium text-background-50">{toast}</span>
          </div>
        </div>
      )}
    </section>
  );
}